(() => {
  'use strict';
  const connected = new WeakSet();
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function installFilm(scope=document){
    scope.querySelectorAll('[data-v11-film-toggle]').forEach(button=>{
      if(connected.has(button))return;
      connected.add(button);
      const scene=button.closest('[data-v9-chamber]');
      const holder=scene?.querySelector('[data-v9-chamber-video]');
      const video=holder?.querySelector('video');
      const label=button.querySelector('[data-v11-film-toggle-label]');
      if(!scene || !video || !label)return;
      const word={play:'PLAY FILM',pause:'PAUSE FILM'};
      let manualPause=reduce() || Boolean(navigator.connection?.saveData);
      scene.dataset.v11FilmPaused=manualPause?'true':'false';
      function sync(){
        const actual=(!manualPause && !video.paused && !document.hidden);
        button.setAttribute('aria-pressed',String(actual));
        label.textContent=actual?word.pause:word.play;
      }
      video.addEventListener('play',sync);
      video.addEventListener('pause',sync);
      document.addEventListener('visibilitychange',sync);
      button.addEventListener('click',()=>{
        manualPause=!video.paused;
        scene.dataset.v11FilmPaused=manualPause?'true':'false';
        if(manualPause){video.pause();sync();return;}
        video.muted=true;video.playsInline=true;video.preload='metadata';
        const result=video.play();if(result && result.catch)result.catch(()=>sync());
        sync();
      });
      sync();
    });
  }
  function installSpin(scope=document){
    scope.querySelectorAll('[data-v11-spin]').forEach(spin=>{
      if(connected.has(spin))return;
      connected.add(spin);
      const stage=spin.querySelector('[data-v11-spin-frames]');
      const imgs=[...spin.querySelectorAll('[data-v11-spin-frame]')];
      const slider=spin.querySelector('[data-v11-spin-slider]');
      const out=spin.querySelector('[data-v11-spin-output]');
      if(!stage || imgs.length<8 || !slider || !out)return;
      let position=0,start=null;
      function paint(index){
        const next=((Math.round(index)%imgs.length)+imgs.length)%imgs.length;
        if(next===position)return;
        imgs[position].hidden=true;
        imgs[next].hidden=false;
        position=next;
        slider.value=String(next);
        out.textContent=String(next+1).padStart(2,'0')+' / '+String(imgs.length).padStart(2,'0');
      }
      slider.addEventListener('input',()=>paint(Number(slider.value)));
      stage.addEventListener('pointerdown',e=>{
        if(e.button!==0)return;
        start={x:e.clientX,pos:position};
        stage.setPointerCapture?.(e.pointerId);
      });
      stage.addEventListener('pointermove',e=>{
        if(!start)return;
        const delta=e.clientX-start.x;
        const jump=Math.trunc(delta/19);
        paint(start.pos+jump);
      });
      const stop=()=>{start=null};
      stage.addEventListener('pointerup',stop);
      stage.addEventListener('pointercancel',stop);
      stage.addEventListener('lostpointercapture',stop);
    });
  }
  const mount=scope=>{installFilm(scope);installSpin(scope)};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
  document.addEventListener('shopify:section:load',event=>mount(event.target));
})();
